import { render, staticRenderFns } from "./StepPrizeTable.vue?vue&type=template&id=420378c6&scoped=true&"
import script from "./StepPrizeTable.vue?vue&type=script&lang=js&"
export * from "./StepPrizeTable.vue?vue&type=script&lang=js&"
import style0 from "./StepPrizeTable.vue?vue&type=style&index=0&id=420378c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420378c6",
  null
  
)

export default component.exports